import React, { memo, useEffect } from 'react';
import { useTranslation } from 'i18n';

import { OrgTypesActions } from 'store/actions';
import { OrgTypesSelectors } from 'store/selectors';

import { useDispatch, useSelector } from 'react-redux';
import {
  clearValueParser,
  idValueFormatter,
  nameValueParser,
  nameValueTransformer,
  titleLabelFormatter,
} from './utils';
import FilterSelectHandler from './FilterSelectHandler';

export interface IOrgTypeFilterProps {
  disabled?: boolean;
  multiple?: boolean;
  name?: string;
  hasFullName?: boolean;
}

const OrgTypeFilter: React.FC<React.PropsWithChildren<IOrgTypeFilterProps>> = (props) => {
  const { disabled, name = 'type', multiple = true, hasFullName = false } = props;
  const [t] = useTranslation();

  const dispatch = useDispatch();

  const orgTypes = useSelector(OrgTypesSelectors.orgTypes);

  useEffect(() => {
    dispatch(OrgTypesActions.getOrgTypes.request());
  }, [dispatch]);

  return (
    <FilterSelectHandler
      multiple={multiple}
      name={name}
      placeholder={t(hasFullName ? 'common:filter.organisationType' : 'common:filter.orgType')}
      disabled={disabled}
      items={orgTypes || []}
      labelFormatter={titleLabelFormatter}
      valueFormatter={idValueFormatter}
      valueTransformer={nameValueTransformer}
      valueParser={nameValueParser}
      clearValueParser={clearValueParser}
    />
  );
};

export default memo(OrgTypeFilter);
